module.exports = __webpack_public_path__ + "img/en_gb.b1303c78.svg";